/**
 * トークンの localStorage 保存・取得・削除。
 *
 * グローバル学び:
 *   - localStorageを使わない方針はあるが、認証トークンはセッション維持の都合で例外
 *   - POTAL/既存サブアプリも localStorage を使っている
 *   - キー名は他アプリと衝突しないよう trendscope_ prefix
 */

const TOKEN_KEY = 'trendscope_token';

export const saveToken = (token: string): void => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const getToken = (): string | null => localStorage.getItem(TOKEN_KEY);

export const clearToken = (): void => {
  localStorage.removeItem(TOKEN_KEY);
};
